export const PastDueIcon = ({
  strokeColor = "var(--color-yellow)",
  ...props
}: any) => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none">
    <path
      d="M7.45185 13.7211C10.6381 13.7211 13.2211 11.1381 13.2211 7.95185C13.2211 4.76559 10.6381 2.18262 7.45185 2.18262C4.26559 2.18262 1.68262 4.76559 1.68262 7.95185C1.68262 11.1381 4.26559 13.7211 7.45185 13.7211Z"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.21371 4.9707L7.21338 8.29044L9.55744 10.6345"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
